import React, { useEffect } from "react";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";

import FormItem from "./../../../shared/items/static/formItem";
import ReportSelect from "../../../shared/items/contols/reportSelect";

import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";

const ReportTypeSelect = (props) => {
  const { selectedReports, onSelectReport, onGetReportsList, reportsListDataState, reportsListData } = props;

  useEffect(() => {
    if (reportsListDataState !== states.READY) {
      onGetReportsList();
    }
  }, []);

  if (reportsListData.length === 0) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Preloader />
      </div>
    );
  }

  return (
    <FormItem>
      <ReportSelect value={selectedReports} handleChange={onSelectReport} placeholder="Выберите тип отчета" options={reportsListData} />
    </FormItem>
  );
};

export default React.memo(withSelectedReports(withReportsList(ReportTypeSelect)));
